<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-if="!fetchData">

      <b-modal id="cancelDeletePeoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to proceed
        </h6>
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Enter a brief explanation of the reason for cancellation of
              deletion (Minimum 10 character):</label>
            <b-form-input id="input-1" v-model="deletePeoModel.reason" type="text"
              placeholder="Enter Reason"></b-form-input>
          </b-form-group>
        </div>
        <div class="buttons">
          <b-button :disabled="(deletePeoModel.reason.length < 10)" size="sm" variant="primary"
            @click="CancelDeletion()">Cancel Deletion</b-button>
          <b-button size="sm" variant="danger" class="ml-2"
            @click="$bvModal.hide('cancelDeletePeoConfirmationModel')">Cancel</b-button>
        </div>
      </b-modal>

      <b-modal id="deletePeoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to delete {{ deletePeoModel.name }}
        </h6>
        <div :class="['disable-wrapper', { disabled: showOtpBox }]">
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Type 'DELETE' and press delete button to complete deletion:</label>
              <b-form-input id="input-1" v-model="deletePeoModel.confirmText" type="text" placeholder="Enter  DELETE"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div>
            <b-form-group id="input-group-1" label-for="input-1">
              <label class="required-label" for="">Enter a brief explanation of the reason for deletion (Minimum 10
                character):</label>
              <b-form-input id="input-1" v-model="deletePeoModel.reason" type="text" placeholder="Enter Reason"
                :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
            </b-form-group>
          </div>
          <div class="buttons">
            <b-button :disabled="(deletePeoModel.confirmText != 'DELETE' || deletePeoModel.reason.length < 10)" size="sm"
              variant="primary" @click="sendOtp()">Delete</b-button>
            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deletePeoConfirmationModel'); otp = null; showOtpBox = false;">Cancel</b-button>
          </div>
        </div>
        <div v-if="showOtpBox" class="mt-3">
          <b-form-group>
            <label class="required-label">Enter OTP to confirm deletion:</label>
            <b-form-input v-model="otp" placeholder="Enter OTP"></b-form-input>
          </b-form-group>

          <p class="text-danger small">Please contact ezygo support for OTP</p>

          <div class="d-flex align-items-center mt-2">
            <b-button variant="success" size="sm" @click="verifyOtp()">
              Verify OTP & DELETE
            </b-button>

            <b-button size="sm" variant="danger" class="ml-2"
              @click="$bvModal.hide('deletePeoConfirmationModel'); otp = null; showOtpBox = false;">
              Cancel
            </b-button>
          </div>


        </div>

      </b-modal>

      <b-row class="control-buttons">
        <b-col v-if="resourceaction == 'list' && !course_id" style="text-align:left;">
          <b-button variant="success" class="text-white sm" size="sm" @click="createEditPeo(null)">Add
            PEO</b-button>
          <!-- <b-button variant="success" class="ml-2 text-white sm" size="sm" @click="downloadPdf()">Download
            PDF</b-button> -->
        </b-col>
        <b-col v-if="(resourceaction == 'createEdit' && peo.id == null && !enablePeoCopy)"
          style="text-align:left;">
          <b-row>
            <b-button variant="success" class="mr-2 text-white sm" size="sm" @click="getCopyPeoOptions">Copy
              From Other Programmes </b-button>
          </b-row>
        </b-col>
        <b-col v-if="resourceaction != 'list'" style="text-align:right;">
          <b-button
            variant="success"
            class="text-white sm mr-2"
            size="sm"
            @click="createUpdatePeo"
            :disabled="actionButton.disabled"
          >
            {{ actionButton.text }}
          </b-button>

          <b-button
            variant="danger"
            class="text-white sm"
            size="sm"
            @click="resourceaction = 'list'"
            :disabled="actionButton.disabled"
          >
            Cancel
          </b-button>
        </b-col>

      </b-row>
      <div v-if="resourceaction == 'list'">
        <h3 style="text-align: center; font-size:18px !important;">
          Programme Educational Objectives (PEO)
        </h3>
        <b-row>
          <b-col sm="12">
            <div class="table-responsive rounded">
              <table class="table table-striped table-bordered">
                <thead class="thead-dark text-left">
                  <tr>
                    <th>
                      SI. No.
                    </th>
                    <th>
                      Code
                    </th>
                    <th>
                      Outcome
                    </th>
                    <th v-if="!course_id"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(peo, reindex) in peos" :key="reindex">
                    <td>{{ peo.si_no }}</td>
                    <td>
                      {{ peo.code }}
                      <div v-if="(peo.deleted_at != null)">
                        <vue-countdown :time="timeToDeleteIn(peo.deleted_at)" v-slot="{ hours, minutes, seconds }">
                          <b-badge variant="danger" style="white-space: nowrap; margin: 2px;">Delete in
                            {{ hours }}:{{ minutes }}:{{ seconds }}
                          </b-badge><b-link
                            @click="deletePeoModel.id = peo.id; $bvModal.show('cancelDeletePeoConfirmationModel')">
                            <b-badge variant="success">Cancel Deletion</b-badge></b-link>
                        </vue-countdown>
                      </div>
                    </td>
                    <td>{{ peo.outcome }}</td>
                    <td v-if="!course_id">
                      <span class="text-info btn m-0 p-0 sm" size="sm" @click="createEditPeo(reindex)"
                        :disabled="actionButton.disabled"><i class="fas fa-pen ml-3"></i></span>
                      <span v-if="(enableDeletePeoButton && peo.deleted_at == null)" :id="'usergroupAdmin' + reIndex"
                        class="btn p-0 m-0 text-info" @click="openDeletePeoModel(peo.id, peo.code)">
                        <i style="color:red;" class="fas fa-trash"></i>
                      </span>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="resourceaction == 'createEdit'">
        <div v-if="enablePeoCopy">
          <h3 style="text-align: center; font-size:18px !important;">
            Copy PEO from other Programme
          </h3>
          <b-form-group>
            <label class="required-label" for="">Choose Programme:</label>
            <b-form-select @change="getUsergroupPeosForPeoCopy" :options="copyPeoUsergroups" v-model="copyPeoUsergroup_id">
            </b-form-select>
            <span v-if="(copyPeoUsergroups.length < 1)" class="text-danger">Loading...</span>
          </b-form-group>
          <ul v-if="copyPeoUsergroup_id">
            <span class="text-danger" v-if="(copyFromPeoOptions.length < 1)">PEO list is empty on selected
              programme</span>

            <li v-for="peoOption in copyFromPeoOptions" :key="peoOption.id">
              <b-form-checkbox v-model="copyFromPeoIds" name="checkbox-peocopyoption" :value="peoOption.id">
                {{ peoOption.code }}-{{ peoOption.outcome }}
              </b-form-checkbox>
            </li>
          </ul>
          <b-row>
            <b-col sm="12" style="text-align:right;">
              <b-button variant="success" class="text-white sm" size="sm" @click="submitCopyPeo"
                :disabled="(copyFromPeoIds.length < 1)">{{ actionButton.text }}</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h3 style="text-align: center; font-size:18px !important;">
            {{ peo.id ? 'Edit PEO' : 'Add new PEO' }}
          </h3>
          <b-row>
            <b-col sm="6">
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">Si. No.:</label>
                <b-form-input id="input-1" v-model="peo.si_no" type="text" placeholder="Enter a Number"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group id="input-group-2" label-for="input-2" description="">
                <label class="required-label" for="">PEO Name:</label>
                <b-form-input id="input-2" v-model="peo.code" type="text" placeholder="PEO 1"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="required-label" for="">PEO Description:</label>
                <b-form-textarea v-model="peo.outcome" placeholder="Description" rows="3" max-rows="6"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { SOFT_DELETE_RETENTION_MINUTES } from "@/constants";
import moment from 'moment';
import VueCountdown from "@chenfengyuan/vue-countdown";
import axios from "axios";
export default {
  props: ['usergroup_id', 'course_id'],
  async created() {
    this.getPeos();
  },
  components: {
    VueCountdown,
  },
  data() {
    return {
      otpSent: false,
      otp: "",
      otpVerified: false,
      showOtpBox: false,
      fetchData: false,
      resourceaction: "list", // list,createEdit
      deletePeoModel: { id: null, name: null, confirmText: '', reason: '' },
      peos: [],
      peo: {
        id: null,
        si_no: '',
        code: '',
        outcome: "",
        usergroup_id: '',
      },
      actionButton: {
        text: "Save",
        disabled: false,
      },

      enablePeoCopy: false,
      copyPeoUsergroups: [],
      copyPeoUsergroup_id: null,
      copyFromPeoOptions: [],
      copyFromPeoIds: [],
      enableDeletePeoButton: true,
      deletedPeo: {},
    };
  },
  methods: {
    async sendOtp() {
      if (
        confirm(
          'WARNING: You are going to delete "' +
          this.deletePeoModel.name +
          '". Do you still want to proceed?'
        ) == true
      ) {

        this.showOtpBox = true;
        const url =
          this.$store.getters.getAPIKey.mainAPI + `/peos/send-delete-otp`;

        await this.$axios.post(url, {
          peo_id: this.deletePeoModel.id
        })
          .then(() => {
            // this.$toast.success("OTP sent to your registered email", {
            //   position: "top",
            //   duration: 5000,
            // });
          })
          .catch(() => {
            this.$toast.error("Failed to send OTP", {
              position: "top",
              duration: 5000,
            });
          });
      }
    },

    async verifyOtp() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/peos/verify-delete-otp`;

      await this.$axios.post(url, {
        otp: this.otp,
        peo_id: this.deletePeoModel.id
      })
        .then(() => {
          this.otpVerified = true;
          this.otp = null;
          this.showOtpBox = false;

          this.deletePeo();
        })
        .catch(() => {
          this.$toast.error("Invalid OTP", {
            position: "top",
            duration: 5000,
          });
        });
    },
    async CancelDeletion() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/peos/${this.deletePeoModel.id}/canceldeletion`;
      this.$axios
        .post(url, { reason: this.deletePeoModel.reason })
        .then(() => {
          this.deletePeoModel = { id: null, name: null, confirmText: '', reason: '' };
          this.otp = null;
          this.showOtpBox = false;
          this.getPeos();
        });
    },
    timeToDeleteIn(deleted_at) {
      const futureTime = moment.utc(deleted_at, 'YYYY-MM-DD HH:mm:ss').add(SOFT_DELETE_RETENTION_MINUTES, 'minutes');
      const currentUTCTime = moment.utc();
      const timeDifferenceInSeconds = futureTime.diff(currentUTCTime, 'seconds');
      return timeDifferenceInSeconds * 1000;
    },
    deletePeo() {
      let id = this.deletePeoModel.id;
      let name = this.deletePeoModel.name;
      this.enableDeletePeoButton = false;
      this.deletedPeo.id = id;
      this.deletedPeo.name = name;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/peos/${id}`;
      this.$axios
        .delete(url, {
          data: { reason: this.deletePeoModel.reason },
        })
        .then(() => {
          this.$toast.success(`${name} deletion initiated successfully`, {
            position: "top-right",
            duration: 6000,
          });
          this.enableDeletePeoButton = true;

          this.deletePeoModel = { id: null, name: null, confirmText: '', reason: '' };
          this.getPeos();
        })
        .catch((error) => {
          this.$toast.error(
            `${name} is failed to delete, ` + error.response.data.message,
            {
              position: "top-right",
              duration: 6000,
            }
          );
          error;
          this.enableDeletePeoButton = true;
        });
    },

    openDeletePeoModel(id, name) {
      this.deletePeoModel = { id: id, name: name, confirmText: '', reason: '' };
      this.$bvModal.show("deletePeoConfirmationModel");
    },

    async submitCopyPeo() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/peos/copy`;

      await axios.post(url, {
        peos: this.copyFromPeoIds,
        copy_to_usergroup: this.usergroup_id,
      })
        .then(() => {
          this.$toast.success("PEO copied successfully", {
            position: "top",
            duration: 3000,
          });
          this.getPeos();
        })
        .catch(() => {
          let errortxt = "Failed to Copy PEO";
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },
    async getCopyPeoOptions() {
      this.copyFromPeoOptions = [];
      this.copyFromPeoIds = [];
      this.copyPeoUsergroups = [];
      this.copyPeoUsergroup_id = null;
      this.enablePeoCopy = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups?allusergroups=1`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach(group => {
            this.copyPeoUsergroups.push({
              value: group.id, text: `${group.code}-${group.name}-${group.scheme}-${group.affiliated_university}`
            });
          });
        })
        .catch((error) => {
          error;
        });

      this.actionButton.text = 'Start Copy';
    },

    async getUsergroupPeosForPeoCopy() {
      this.fetchData = true;
      this.copyFromPeoOptions = [];
      this.copyFromPeoIds = [];
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/peos?usergroup=${this.copyPeoUsergroup_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.copyFromPeoOptions = response.data;

          // auto select all PEOs from the selected programme
          this.copyFromPeoIds = response.data.map(peo => peo.id);
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },

    async createEditPeo(index) {
      this.enablePeoCopy = false;

      this.peo = {
        id: null,
        si_no: this.peos.length + 1,
        code: '',
        outcome: "",
        usergroup_id: this.usergroup_id,
      };
      if (index !== null) this.peo = this.peos[index];

      this.resourceaction = 'createEdit';
    },
    async getPeos() {
      this.fetchData = true;
      this.resourceaction = 'list';
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/peos?usergroup=${this.usergroup_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.peos = response.data;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },
    async createUpdatePeo() {
      this.fetchData = true;
      this.actionButton = {
        text: "Saving...",
        disabled: true,
      };
      let url = this.$store.getters.getAPIKey.mainAPI + `/peos`;
      let action = 'post';
      if (this.peo.id) {
        url += `/${this.peo.id}`;
        action = 'put';
      }

      await axios[action](url, this.peo)
        .then(() => {
          this.$toast.success("PEO created successfully", {
            position: "top",
            duration: 3000,
          });
          this.getPeos();
        })
        .catch((error) => {
          let errortxt = "";
          if (error.response)
            if (error.response.status == 422) {
              let errormsgs = error.response.data.errors;
              for (const key in errormsgs) {
                errortxt = errormsgs[key][0];
              }
            } else {
              errortxt = error.response.data.message;
            }
          else {
            errortxt = "Failed to Update/Create";
          }
          this.$toast.error(errortxt, {
            position: "top",
            duration: 7000,
          });
          return;
        });

      this.fetchData = false;
      this.actionButton = {
        text: "Save",
        disabled: false,
      };
    },

  },
};
</script>

<style>
.disable-wrapper.disabled {
  background-color: #e0e0e0;
  /* gray */
  pointer-events: none;
  /* disable all */
  opacity: 0.7;
}

.tag-button button {
  font-size: 9px !important;
  padding: 3px;
}
</style>
